<template>
	<div class="acoj-render">
		<div class="header-wrap" v-if="problemInfo">
      {{ problemInfo.problem_id }}.&nbsp;{{ problemInfo.title }}
      <el-tag
          v-for="(tag, index) in problemInfo.problem_tag"
          :key="index"
          effect="dark"
          size="small"
          :class="parseTag(tag).class"
          style="cursor: pointer;margin-left: 20px;"
      ><span :style="{fontSize: tagFontSize + 'rem'}">{{ parseTag(tag).name }}</span></el-tag>
    </div>
		<div class="main-con">
			<div class="side-wrap">
				<el-tabs v-model="activeName" @tab-click="handleTabClick">
					<el-tab-pane name="1">
						<span slot="label"><i class="iconfont icon-subject"></i>&nbsp;题目详情</span>
						<div class="subject-con" v-if="problemInfo">
							<div class="subject-title latex-format" v-html="problemInfo.description"></div>
							<div class="subject-item">
								<p><b>输入格式：</b></p>
								<pre class="latex-format" v-html="problemInfo.input"></pre>
							</div>
							<div class="subject-item">
								<p><b>输出格式：</b></p>
								<pre class="latex-format" v-html="problemInfo.output"></pre>
							</div>
							<div class="subject-item" v-if="problemInfo.hint">
								<p><b>提示：</b></p>
								<pre class="latex-format" v-html="problemInfo.hint"></pre>
							</div>
							<div class="subject-item" v-if="problemInfo.restrict">
								<p><b>限制：</b></p>
								<pre v-html="problemInfo.restrict"></pre>
							</div>
							<div class="subject-item subject-item-sample" v-if="problemInfo.sample_input">
								<p><b>样例：</b></p>
								<div><span style="padding-bottom: 10px;display: block">输入：</span><pre style="white-space: pre;overflow: auto;" v-html="problemInfo.sample_input"></pre></div>
								<div><span style="padding-bottom: 10px;display: block">输出：</span><pre style="white-space: pre;overflow: auto;" v-html="problemInfo.sample_output"></pre></div>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane name="2" v-if="!hideBlock.includes('evaluation')">
						<span slot="label"><i class="iconfont icon-evaluation"></i>&nbsp;测评详情</span>
						<div class="evaluation-con" v-if="userResult && userResult.result">
							<div class="evaluation-item">
								<p class="title">测评状态</p>
								<div class="result" :class="setResultMap(userResult.result.result).style">
									<div>{{ setResultMap(userResult.result.result).text }}</div>
									<div style="margin-left: 10px;">{{ userResult.result.sum }}</div>
								</div>
								<div class="lang">语言：<span>{{ userResult.result.language_name }}</span></div>
								<div class="status">
									<div>用时：<span>{{ userResult.result.time }} ms</span></div>
									<div>内存：<span>{{ userResult.result.memory }} kb</span></div>
									<div>代码长度：<span>{{ userResult.result.code_length }}</span></div>
								</div>
							</div>
							<div class="evaluation-item">
								<p class="title">测试数据</p>
								<el-table class="evaluation-item-table" :data="userResult.result.testing_point" style="width: 100%">
									<el-table-column label="编号" align="center" min-width="95">
										<template slot-scope="scope">{{ scope.$index + 1 }}</template>
									</el-table-column>
									<el-table-column label="结果" align="center" min-width="120">
										<template slot-scope="scope">
											<div :class="setResultMap(scope.row.flag).style">
												{{ acojResultMap(scope.row.flag) }}
											</div>
										</template>
									</el-table-column>
<!--									<el-table-column label="对比" align="center" min-width="180">-->
<!--										<template slot-scope="scope">-->
<!--											<div v-if="scope.row.score !== 0" class="green">AC</div>-->
<!--											<div v-else>-->
<!--												<div v-if="scope.row.ac && scope.row.diff">-->
<!--													<el-button size="mini" @click="openDialog(scope.$index)">查看-->
<!--													</el-button>-->
<!--&lt;!&ndash;													<el-button size="mini">下载</el-button>&ndash;&gt;-->
<!--												</div>-->
<!--												<div v-else class="text-secondary">暂无数据</div>-->
<!--											</div>-->
<!--										</template>-->
<!--									</el-table-column>-->
									<el-table-column prop="score" label="得分" align="center" min-width="100" />
									<el-table-column prop="usedtime" label="耗时(ms)" align="center" min-width="100" />
									<el-table-column label="下载" align="center" min-width="125">
										<template slot-scope="scope">
											<div v-if="scope.row.score === 0">
                        <el-button size="mini" :style="{backgroundColor:scope.row.allowDownload?'#27A364':'#909399!important'}" :disabled="scope.row.allowDownload !== true" @click="downloadTestPointCountAct(scope.row,scope.$index)">下载</el-button>
                      </div>
											<div v-else class="green">AC 不提供下载</div>
										</template>
									</el-table-column>
								</el-table>
							</div>
							<div class="evaluation-item" v-if="userResult.result.runtimeinfo">
								<p class="title">编译信息</p>
								<pre style="white-space: pre;overflow: auto">{{ userResult.result.runtimeinfo }}</pre>
							</div>
						</div>
						<div class="no-data-wrap" v-else>暂无数据</div>
						<el-dialog :title="dialog.title" :visible.sync="dialog.visible" append-to-body left>
							<div class="dialog-content contrast-wrap">
								<div class="dialog-content__left dialog-content-item">
									<el-tabs type="border-card">
										<el-tab-pane label="预期">
											<pre>{{ dialog.ac }}</pre>
										</el-tab-pane>
									</el-tabs>
								</div>
								<div class="dialog-content__right dialog-content-item">
									<el-tabs type="border-card">
										<el-tab-pane label="实际">
											<pre>{{ dialog.diff }}</pre>
										</el-tab-pane>
									</el-tabs>
								</div>
							</div>
						</el-dialog>
					</el-tab-pane>
          <el-tab-pane name="3" v-if="!hideBlock.includes('submitRecord')">
            <span slot="label" class="tab-area"><i class="el-icon-notebook-2" />&nbsp;提交记录</span>
            <el-table
                v-if="userResultRecord"
                :data="userResultRecord"
                element-loading-text="Loading"
                fit
                class="problem-table"
                ref="record"
                :expand-change="recordTableCurrentRow"
            >
              <el-table-column type="expand">
                <template slot-scope="scope">
                    <pre style="padding-right: 10px;user-select: none;cursor: not-allowed">
                      <el-tag class="hljs-el-tag" size="mini" type="info">禁止复制，自己写！（为巩固知识，往期代码复制功能已禁用）</el-tag>
                      <code class="hljs" v-html="translateCode(scope.row.source_code)" />
                    </pre>
                </template>
              </el-table-column>
              <el-table-column label="提交结果" prop="result">
                <template slot-scope="scope">
                  <div :class="setResultMap(scope.row.result)?setResultMap(scope.row.result).style:''">
                    {{ setResultMap(scope.row.result)?setResultMap(scope.row.result).text:'未知错误' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="执行用时">
                <template slot-scope="scope">
                  {{ scope.row.result === 4? scope.row.time +' ms': 'N/A' }}
                </template>
              </el-table-column>
              <el-table-column label="内存消耗">
                <template slot-scope="scope">
                  {{ scope.row.result === 4? scope.row.memory +' kb': 'N/A' }}
                </template>
              </el-table-column>
              <el-table-column label="语言">
                <template slot-scope="scope">
                  {{ studentLang[scope.row.language]?studentLang[scope.row.language].lang:'未知' }}
                </template>
              </el-table-column>
              <el-table-column label="提交时间" prop="in_date" width="200" />
            </el-table>
          </el-tab-pane>
				</el-tabs>
			</div>
			<div class="editor-wrap">
				<div class="editor-top">
          <div v-if="!hideBlock.includes('changeLang')">
            <el-select v-model="studentAnswer.langType" class="lang-select" style="font-size: 1rem" size="small"
                       @change="changeLang">
              <el-option v-for="(option, index) in studentLang" :key="index" :label="option.lang"
                         :value="option.value" />
            </el-select>
            <div style="display: inline-block;font-size: .6rem;margin-left: 0.6rem">切换语言将不会保存代码</div>
          </div>
					<el-button v-if="!hideBlock.includes('submitBtn')" type="success" style="font-size: 1rem" size="small" @click="submitCode">提交</el-button>
				</div>
				<div class="editor-bg">
					<ul class="code-edit">
						<li @click="zoom('plus')"><i class="iconfont icon-enlarge"></i></li>
						<li @click="zoom()"><i class="iconfont icon-narrow"></i></li>
						<li @click="formatCodeAction" v-if="lang === 'c_cpp'">格式化代码</li>
					</ul>
					<div class="editor-scroll">
						<div class="editor-con" :style="{ fontSize: ACEEditorFontSize + 'px' }" :id="elementId"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import hljs from 'highlight.js/lib/core'
import cpp from 'highlight.js/lib/languages/cpp'
import '@highlightjs/vue-plugin'
import 'highlight.js/styles/monokai-sublime.css'
hljs.registerLanguage('cpp', cpp)
import {formatCode} from "@/api/homework";
import {downloadTestPoint, downloadTestPointCount} from "@/api/xinAoTraining";

	// 常量定义
	const ACOJ_RESULT_MAP = ['', '', '', '', 'AC', 'PE', 'WA', 'TLE', 'MLE', 'OLE', 'RE', 'CE', '', '', '']
	const resultMap = [{
			'style': 'gray',
			'text': '等待'
		},
		{
			'style': 'gray',
			'text': '等待重判'
		},
		{
			'style': 'orange',
			'text': '编译中'
		},
		{
			'style': 'orange',
			'text': '运行并评判'
		},
		{
			'style': 'green',
			'text': '正确'
		},
		{
			'style': 'red',
			'text': '格式错误'
		},
		{
			'style': 'red',
			'text': '答案错误'
		},
		{
			'style': 'red',
			'text': '时间超限'
		},
		{
			'style': 'red',
			'text': '内存超限'
		},
		{
			'style': 'red',
			'text': '输出超限'
		},
		{
			'style': 'navy',
			'text': '运行错误'
		},
		{
			'style': 'navy',
			'text': '编译错误'
		},
		{
			'style': 'navy',
			'text': '运行错误'
		},
		{
			'style': 'navy',
			'text': '编译错误'
		},
		{
			'style': 'green',
			'text': '编译成功'
		}
	]
	export default {
		name: "acojRender",
		props: {
			problemInfo: {
				type: Object,
				default: null
			},
			userResult: {
				type: Object,
				default: null
			},
      userResultRecord: {
        type: Array,
        default: null
      },
			// submitBtn提交按钮,evaluation测评详情，submitRecord提交记录
			hideBlock: {
        type: String,
        default: ""
      }
		},
		components: {},
		data() {
			return {
				activeName: "1",
        userResultRecordLoading: false,
				studentLang: {
				  // 0:{
          //     lang: 'c',
          //     value: '0'
				  // },
          1:{
              lang: 'c++',
              value: '1'
            },
          // 2:{
          //     lang: 'Pascal',
          //     value: '2'
          //   },
          // 3:{
          //     lang: 'java',
          //     value: '3'
          //   },
          6:{
              lang: 'python',
              value: '6'
            },
          // 12:{
          //     lang: 'python3',
          //     value: '12'
          //   }
				},
				studentAnswer: { // 选择的语言
					code: '',
					langType: '1'
				},
				elementId: 'acojEditor-' + this.randomString(8), // 编辑器ID
				editor: null, // 编辑器
				lang: 'c_cpp',
				testing_point: null,
				dialog: {
					title: '输出对比',
					visible: false,
					ac: '',
					did: ''
				},
				ACEEditorFontSize: 27, // 字体大小
        tagFontSize: 0.7
			}
		},
		created() {
      if(parseInt(window.document.body.clientWidth) <= 1280){
        this.ACEEditorFontSize = 22;
      }else if(parseInt(window.document.body.clientWidth) < 1900){
        this.tagFontSize = 0.8
      }
    },
		mounted() {
			this.initEditor();
			this.formatLatex();
		},
		computed: {
			acojResultMap() {
				return (flag) => {
					return ACOJ_RESULT_MAP[flag]
				}
			},
			setResultMap() {
				return (result) => {
					return resultMap[result]
				}
			}
		},
		watch: {
			userResult(newData) {
				if (newData && newData.result) {
					if (newData.result.testing_point) {
						this.testing_point = this.setAllowDownload(newData.result.testing_point)
					} else {
						this.testing_point = null
					}
					this.studentAnswer.langType = '' + newData.result.language
          console.log('userResult=============',newData)
					this.editor.getSession().setValue(newData && newData.result.source.length > 0 ? newData.result.source +
						'\n' : '');
				} else {
					this.resetEditor()
				}
				this.lang = this.getLangMode(this.studentAnswer.langType)
			},
			problemInfo(val) {
        this.activeName = "1"
				// if (this.activeName != "1") this.activeName = "2";
        this.$nextTick(()=>{
          this.formatLatex()
        })
			},
      lang(val) {
        if (this.editor) {
          this.editor.getSession().setMode('ace/mode/' + val)
        }
      }
		},
		methods: {
			getLangMode: function(langType) {
        langType = langType.toString()
				switch (langType) {
					case '0':
					case '1':
						return 'c_cpp'
					case '2':
						return 'pascal'
					case '3':
						return 'java'
					case '6':
						return 'python'
				}
				return 'c_cpp'
			},
			initEditor() { // 初始化编辑器
        let decodeCode = this.initCode(this.studentAnswer.langType)
				if (this.userResult && this.userResult.result.source && this.userResult.result
					.source.length > 0) {
					decodeCode = this.userResult.result.source;
				}
				this.editor = window['ace'].edit(this.elementId)
				this.editor.setTheme('ace/theme/cobalt')
				this.editor.setOption('showInvisibles', true)
				this.editor.setOption('tabSize', 4)
				this.editor.setFontSize(this.ACEEditorFontSize)
				this.editor.getSession().setMode('ace/mode/' + this.lang)
				this.editor.getSession().setValue(decodeCode && decodeCode.length > 0 ? decodeCode + '\n' : '')
				// document.getElementById(this.elementId).style.fontSize = '14px'
				this.editor.setOptions({
					enableBasicAutocompletion: false,
					enableLiveAutocompletion: false
				})
				this.editor.renderer.setShowGutter(true)
			},
			submitCode() { // 提交代码
				const code = this.editor.getSession().getValue()
				const data = {
					codeContent: code,
					language: this.studentAnswer.langType
				}
				this.$emit('commitResult', data);
				if(!this.hideBlock.includes("evaluation") && !this.hideBlock.includes("submitRecord")){
					this.activeName = "2"
				}
			},
			openDialog(index) {
				this.dialog.title = `输出对比 - 测试点${index}`
				const testingPoint = this.testing_point[index]
				this.dialog.ac = testingPoint.ac
				this.dialog.diff = testingPoint.diff
				this.dialog.visible = true
			},
			setAllowDownload(arr) {
				const index = arr.findIndex(ele => {
					return Number(ele.flag) === 6
				})
				if (index === -1) return arr
				arr[index].allowDownload = true // 暂时都不允许下载测试点
				return arr
			},
			zoom(type) { // 缩放编辑器字体大小
				if (type === 'plus') {
					this.ACEEditorFontSize += 1
				} else {
					if (this.ACEEditorFontSize > 12) {
						this.ACEEditorFontSize -= 1
					}
				}
			},
			formatCodeAction(){
        formatCode({ code: this.editor.getValue(), language: this.studentAnswer.langType }).then(res => {
          this.editor.setValue(res.data, 1)
        })
			},
      changeLang(langType) { //切换语言
        this.lang = this.getLangMode(langType)
        let decodeCode = this.initCode(langType)
        this.editor.getSession().setValue(decodeCode && decodeCode.length > 0 ? decodeCode + '\n' : '')
      },
			randomString(e) {
				e = e || 32
				const t = '12345678'
				const a = t.length
				let n = ''
				for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
				return n
			},
      lineBreak(data) {
        return data.replace(/\r\n|\n/g,'<br/>').replace(/\s/g,'&ensp;');
      },
      formatLatex() {
        const that = this
        const ele = ['latex-format']
        ele.forEach(function(v) {
          const katexDom = document.getElementsByClassName(v)
          for (var i = 0; i < katexDom.length; i++) {
            that.$formula(katexDom[i])
          }
        })
      },
      handleTabClick(tab, event) {
			  console.log(tab)
        if (tab.name === '3') {
          const that = this
          that.userResultRecordLoading = true
          that.$emit('loadUserResultRecord', function(res) {
            that.userResultRecordLoading = false
          })
        }
      },
      resetEditor() {
        // this.studentAnswer.langType = '1'
        const langType = this.getLangMode(this.studentAnswer.langType)
        let decodeCode = this.initCode(this.studentAnswer.langType)
        console.log(langType)
        console.log(decodeCode)
        this.editor.getSession().setValue(decodeCode);
        this.editor.getSession().setMode('ace/mode/' + langType)
        this.testing_point = null
      },
      translateCode(code) {
        return hljs.highlightAuto(code).value
      },
      parseTag(tag) {
        let type = tag.type_id
        if (tag.type_id === 1 && tag.pid === 0) {
          type = 4
        }
        return {
          class: this.tagTypeClass(type, 1),
          name: tag.tag_name,
          tag_name: tag.tag_name,
          tag_id: tag.tag_id
        }
      },
      tagTypeClass(type, effect) {
        if (type === 1) {
          return effect ? 'tag-blue-hover' : 'tag-blue'
        } else if (type === 2) {
          return effect ? 'tag-purpose-hover' : 'tag-purpose'
        } else if (type === 3) {
          return effect ? 'tag-deepblue-hover' : 'tag-deepblue'
        } else if (type === 4) {
          return effect ? 'tag-orange-hover' : 'tag-orange'
        }
      },
      recordTableCurrentRow(row){
			  this.$refs.record.setCurrentRow(row)
      },
      downloadTestPointCountAct(info, index) {
        if (this.downloading) {
          return false
        }
        this.downloading = true
        downloadTestPointCount({ testPoint: info.fname.split('.')[0], problemId: this.problemInfo.problem_id, solutionId: this.userResult.result.solution_id }).then(res => {
          if (res.status === 1) {
            this.downloadTextPointAct(info, index)
            this.$message({
              type: 'info',
              message: res.message
            })
          }
          this.downloading = false
        }).catch(()=>{
          this.downloading = false
        })
      },
      downloadTextPointAct(info, index) {
        downloadTestPoint({ testPoint: info.fname.split('.')[0], problemId: this.problemInfo.problem_id, solutionId: this.userResult.result.solution_id }).then(res => {
          const downloadName = `${this.problemInfo.title}_test_point_${index}.zip`
          const blob = new Blob([res.data], { type: 'application/octet-stream' })
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, downloadName)
          } else {
            const link = document.createElement('a')
            const evt = document.createEvent('HTMLEvents')
            evt.initEvent('click', false, false)
            link.href = URL.createObjectURL(blob)
            link.download = downloadName
            link.style.display = 'none'
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
        }).catch((res) => {
        }).finally(() => {
        })
      },
      initCode(langType) {
        let decodeCode
        langType = langType.toString()
        switch (langType) {
          case '0':
          case '1':
            decodeCode = '#include <iostream>\n' +
                '#include <cstdio>\n' +
                'using namespace std;\n' +
                'int main()\n' +
                '{\n' +
                '    ' +
                '\n' +
                '    return 0;\n' +
                '}'
            break
          case '2':
          case '3':
          case '6':
            decodeCode = ''
            break
          default:
            decodeCode = '#include <iostream>\n' +
                '#include <cstdio>\n' +
                'using namespace std;\n' +
                'int main()\n' +
                '{\n' +
                '    ' +
                '\n' +
                '    return 0;\n' +
                '}'
        }
        return decodeCode
      }
		}
	}
</script>

<style lang="scss" scoped>
	.acoj-render {
		color: #FFF;
		height: 100%;

		.header-wrap {
			font-size: 22px;
			font-weight: 500;
			margin-bottom: 10px;
		}

		.main-con {
			display: flex;
			padding: 0 0 0 10px;
			font-size: 1rem;
			height: calc(100% - 39px);

			p {
				margin: 0 0 4px 0;
			}

			pre {
        margin: 0 0 10px 0;
        background: #1D4E64;
        color: #BCF3FF;
        border-radius: 6px;
        padding: 20px 20px;
        white-space: inherit;
        word-wrap: break-word;
        line-height: 2;
        font-family: Courier,Source Han Sans SC !important;
			}

			.side-wrap {
				width: 50%;
				margin-right: 20px;

				.subject-con {
					padding-right: 10px;

					.subject-title {
						padding: 0 0 20px 0;
            line-height: 2!important;
            font-size: 1rem;
            font-family: Courier,Source Han Sans SC !important;
            color: white!important;
            ::v-deep p {
              line-height: 2!important;
              font-size: 1rem!important;
              font-family: Courier,Source Han Sans SC !important;
              color: white!important;
              span {
                line-height: 2!important;
                font-size: 1rem!important;
                font-family: Courier,Source Han Sans SC !important;
                color: white!important;
              }
            }
					}

					.subject-item {
            margin-left: 10px;
            line-height: 2!important;
            font-size: 1rem!important;
            font-family: Courier,Source Han Sans SC !important;
            ::v-deep b{
              color: #ffffff!important;
            }
            ::v-deep p {
              color: #BCF3FF!important;
              line-height: 2!important;
              font-size: 1rem!important;
              font-family: Courier,Source Han Sans SC !important;
              span {
                color: #BCF3FF!important;
                line-height: 2!important;
                font-size: 1rem!important;
                font-family: Courier,Source Han Sans SC !important;
              }
            }
					}
          .subject-item-sample{
            line-height: normal!important;
            ::v-deep pre {
              line-height: normal!important;
            }
            ::v-deep p {
              line-height: normal!important;
              span {
                line-height: normal!important;
              }
            }
          }
				}

				.no-data-wrap {
					text-align: center;
					font-size: 18px;
					margin-top: 30px;
				}

				.evaluation-con {
					padding-right: 10px;

					.evaluation-item {
						margin-bottom: 20px;
						padding-left: 20px;
            .evaluation-item-table{
              border-radius: 5px;
              background:transparent;
              ::v-deep tr{
                background:transparent;
              }
              ::v-deep th.el-table__cell{
                background-color: rgba(0, 0, 0, 0);
              }
              ::v-deep td.el-table__cell{
                background: rgba(201,238,255,0.15);
              }
              ::v-deep .el-table__body tr:hover>td.el-table__cell {
                background-color: rgba(0, 0, 0, 0) !important;
              }
              ::v-deep .current-row>td.el-table__cell{
                background-color: rgba(0, 0, 0, 0);
              }
              ::v-deep .el-table__expanded-cell{
                background: transparent!important;
              }
              ::v-deep pre{
                background: transparent;
                padding: 0;
              }
              ::v-deep .el-table__empty-block{
                background: rgba(201,238,255,0.15);
              }
            }
						.result {
							display: flex;
						}

						.title {
							margin-left: -10px;
						}

						.lang {
							margin-top: 8px;
						}

						.status {
							display: flex;
							justify-content: start;
							margin-top: 8px;

							div {
								margin-right: 20px;
							}
						}

						.el-table {

							.el-button {
								border: none;
								color: #FFF;
							}
						}
						::v-deep .el-table__body tr.current-row>td.el-table__cell,
						::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
              background: rgba(201,238,255,0.15);
						}
					}
				}

				::v-deep .el-tabs {
					height: 100%;
          .el-tabs__item.is-active{
            font-size: 1rem;
            i{
              font-size: 1rem;
            }
          }
          .el-tabs__item{
            font-size: 0.7rem;
            i{
              font-size: 0.7rem;
            }
          }
					.el-tabs__content {
						height: calc(100% - 56px);
						overflow: auto;
					}
				}
        .problem-table{
          background:transparent;
          ::v-deep .el-table__expand-icon{
            color: white;
          }
          ::v-deep tr{
            background:transparent;
          }
          ::v-deep th.el-table__cell{
            background-color: rgba(0, 0, 0, 0);
          }
          ::v-deep td.el-table__cell{
            background: rgba(201,238,255,0.15);
          }
          ::v-deep .el-table__body tr:hover>td.el-table__cell {
            background-color: rgba(0, 0, 0, 0);
          }
          ::v-deep .current-row>td.el-table__cell{
            background-color: rgba(0, 0, 0, 0);
          }
          ::v-deep .el-table__expanded-cell{
            background: transparent!important;
          }
          ::v-deep pre{
            background: transparent;
            padding: 0;
            .hljs-el-tag{
              display: none;
              position: absolute;
              left: calc(100% - 370px);
              top: 25px;
              line-height: 20px;
            }
          }
          ::v-deep pre:hover{
            .hljs-el-tag{
              display: block;
            }
          }
          ::v-deep .el-table__empty-block{
            background: rgba(201,238,255,0.15);
          }

        }
			}

			.editor-wrap {
				width: 50%;

				.editor-top {
					display: flex;
					justify-content: space-between;

					::v-deep .el-input .el-input__inner {
						background-color: #4E7086;
						color: #FFF;
						border: none;
					}
				}

				.editor-bg {
					height: calc(100% - 70px);
					margin-top: 5px;
					border-image-source: url(~@/assets/img/editorBg.png);
					border-image-slice: 15 18 15 18 fill;
					border-top: 15px solid;
					border-right: 18px solid;
					border-bottom: 15px solid;
					border-left: 18px solid;
					position: relative;

					.code-edit {
						position: absolute;
						display: flex;
						right: -5px;
						top: 5px;
						z-index: 999;
            font-size: 0.6rem;
						li {
							margin-right: 10px;
							border: 1px solid #FFF;
							border-radius: 4px;
							height: 18px;
							line-height: 15px;
							padding: 0 10px;
							cursor: pointer;
              background-color: #002240;
							.iconfont {
								font-size: 12px;
							}
						}

						li:hover{
							background-color: #FFF;
							color: #333;

							.iconfont{
								color: #333;
							}
						}
					}

					.editor-scroll {
						height: 100%;
						overflow: auto;

						.editor-con {
							// min-height: 480px;
							height: 100%;
						}
					}
				}
			}

			.gray {
				color: #909399;
			}

			.orange {
				color: #E6A23C;
			}

			.green {
				color: #67C23A;
			}

			.red {
				color: #F56C6C;
			}

			.navy {
				color: #409EFF;
			}
		}
	}
  .tag-gray {
    color: rgb(191, 191, 191);
    border: 1px solid rgb(191, 191, 191);
    background: rgb(248, 248, 248);
    cursor: pointer;
  }

  .tag-gray-hover,.tag-gray:hover {
    color: #fff;
    border: 1px solid rgb(191, 191, 191);
    background: rgb(191, 191, 191);
  }

  .tag-red {
    color: rgb(252, 79, 100);
    border: 1px solid rgb(252, 79, 100);
    background: rgb(255, 237, 239);
    cursor: pointer;
  }

  .tag-red-hover,.tag-red:hover {
    color: #fff;
    border: 1px solid rgb(252, 79, 100);
    background: rgb(252, 79, 100);
  }

  .tag-orange {
    color: rgb(241, 155, 44);
    border: 1px solid rgb(241, 155, 44);
    background: rgb(255, 243, 227);
    cursor: pointer;
  }

  .tag-orange-hover,.tag-orange:hover {
    color: #fff;
    border: 1px solid rgb(241, 155, 44);
    background: rgb(241, 155, 44);
  }

  .tag-yellow {
    color: rgb(239, 196, 22);
    border: 1px solid rgb(239, 196, 22);
    background: rgb(253, 248, 227);
    cursor: pointer;
  }

  .tag-yellow-hover,.tag-yellow:hover {
    color: #fff;
    border: 1px solid rgb(239, 196, 22);
    background: rgb(239, 196, 22);
  }

  .tag-green {
    color: rgb(87, 194, 45);
    border: 1px solid rgb(87, 194, 45);
    background: rgb(238, 249, 234);
    cursor: pointer;
  }

  .tag-green-hover,.tag-green:hover {
    color: #fff;
    border: 1px solid rgb(87, 194, 45);
    background: rgb(87, 194, 45);
  }

  .tag-blue {
    color: rgb(59, 153, 217);
    border: 1px solid rgb(59, 153, 217);
    background: rgb(235, 245, 251);
    cursor: pointer;
  }

  .tag-blue-hover,.tag-blue:hover {
    color: #fff;
    border: 1px solid rgb(59, 153, 217);
    background: rgb(59, 153, 217);
  }

  .tag-purpose {
    color: rgb(156, 68, 204);
    border: 1px solid rgb(156, 68, 204);
    background: rgb(245, 236, 250);
    cursor: pointer;
  }

  .tag-purpose-hover,.tag-purpose:hover {
    color: #fff;
    border: 1px solid rgb(156, 68, 204);
    background: rgb(156, 68, 204);
  }

  .tag-deepblue {
    color: rgb(15, 32, 103);
    border: 1px solid rgb(15, 32, 103);
    background: rgb(231, 232, 240);
    cursor: pointer;
  }

  .tag-deepblue-hover,.tag-deepblue:hover {
    color: #fff;
    border: 1px solid rgb(15, 32, 103);
    background: rgb(15, 32, 103);
  }
</style>
